import React from 'react';

export default function DangerAlert(props) {
    return (
        <div className="tw-p-4 tw-mb-4 tw-text-sm tw-text-red-800 tw-rounded-lg tw-bg-red-50 tw-dark:bg-gray-800 tw-dark:text-red-400" role="alert">
            {props.message}
        </div>
    );
}
